import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-end flex-wrap-reverse gap-x1 mr-x2 ml-auto"
}
const _hoisted_2 = ["src", "alt"]

import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import { Certificate } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotCertifications',
  props: {
    certificates: null
  },
  setup(__props: any) {




const getCertificationImageUrl = (imageUrl: string) => {
    return generateCdnUrlWithParams(
        imageUrl,
        { format: 'auto', width: 30, height: 30 },
        true);
};

return (_ctx: any,_cache: any) => {
  return (__props.certificates?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.certificates, (certificate) => {
          return (_openBlock(), _createElementBlock("div", {
            key: certificate.imageUrl,
            class: "opacity-75 w-25"
          }, [
            (certificate.imageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: getCertificationImageUrl(certificate.imageUrl),
                  alt: certificate.name,
                  width: "30"
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})